import React from "react";
import { Skeleton } from "../PainelShimmerChrome";
import "./MobileUsuariosSkeleton.scss";

const ROW_COUNT = 6;

interface MobileUsuariosSkeletonProps {
  isDarkMode?: boolean;
}

const MobileUsuariosSkeleton: React.FC<MobileUsuariosSkeletonProps> = ({
  isDarkMode = false,
}) => (
  <div
    className={`mobile-usuarios-skeleton${isDarkMode ? " mobile-usuarios-skeleton--dark" : ""}`}
    aria-busy="true"
    aria-label="Carregando usuários"
  >
    {Array.from({ length: ROW_COUNT }, (_, i) => (
      <div
        key={i}
        className={`mobile-usuarios-skeleton__card${i % 2 ? " is-zebra" : ""}`}
      >
        <div className="mobile-usuarios-skeleton__header">
          <div className="mobile-usuarios-skeleton__identity">
            <Skeleton height={15} width={140} />
            <Skeleton height={12} width={180} />
            <Skeleton height={12} width={120} />
          </div>
          <div className="mobile-usuarios-skeleton__actions">
            <Skeleton height={36} width={36} borderRadius="50%" />
            <Skeleton height={36} width={36} borderRadius="50%" />
          </div>
        </div>
      </div>
    ))}
  </div>
);

export default MobileUsuariosSkeleton;
